import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

// Empty access control - allows all users
export const retailerContactViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RetailerContactManagementView],
}

export const retailerContactModifyAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerContactManagementModify,
    Permission.RetailerContactManagementView,
  ],
}

export const retailerContactAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.retailerContact],
}
